module.exports = __webpack_public_path__ + "static/media/Video_Marker.ff636c26.svg";